import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtIDR } from "../../lib/api";
import { fmtUSD } from "../../lib/currency";
import { inputCls, Field, Panel, btnPrimary, errMsg } from "./ui";

export default function CurrencyTab() {
  const [fx, setFx] = useState(null);
  const [margin, setMargin] = useState("0");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/fx").then((r) => { setFx(r.data); setMargin(String(r.data.margin_idr)); }).catch((e) => toast.error(errMsg(e)));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const r = await api.put("/settings/fx", { margin_idr: Number(margin) });
      setFx(r.data);
      toast.success("Selisih kurs disimpan");
    } catch (err) { toast.error(errMsg(err)); } finally { setSaving(false); }
  };

  if (!fx) return <Panel testId="fx-panel"><p className="text-sm text-[#A8A8AD]">Memuat kurs...</p></Panel>;
  const preview = fx.market_rate + Number(margin || 0);

  return (
    <Panel title="Kurs Mata Uang ($ ↔ IDR)" testId="fx-panel">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm mb-6">
        <div><div className="text-xs uppercase tracking-widest text-[#A8A8AD]">Kurs pasar</div><div data-testid="fx-market" className="text-lg text-[#F5F3ED] font-bold">{fmtIDR(fx.market_rate)}</div>
          <div className="text-xs text-[#A8A8AD]">{fx.source} · {new Date(fx.fetched_at).toLocaleString()}</div></div>
        <div><div className="text-xs uppercase tracking-widest text-[#A8A8AD]">Kurs dipakai toko</div><div data-testid="fx-rate" className="text-lg text-[#D4AF37] font-bold">$1 = {fmtIDR(fx.rate)}</div></div>
        <div><div className="text-xs uppercase tracking-widest text-[#A8A8AD]">Contoh</div><div className="text-[#F5F3ED]">Rp150.000 = {fmtUSD(150000 / preview)}</div></div>
      </div>
      <form onSubmit={save} className="flex flex-col md:flex-row gap-4 md:items-end">
        <Field label="Selisih per $1 (IDR, boleh minus)" className="md:w-72">
          <input data-testid="fx-margin-input" type="number" step="1" min="-100000" max="100000" required className={inputCls} value={margin} onChange={(e) => setMargin(e.target.value)} />
        </Field>
        <div className="text-xs text-[#A8A8AD] md:pb-2">Kurs toko = kurs pasar + selisih = <span className="text-[#D4AF37]">{fmtIDR(preview)}</span>. Selisih plus membuat harga dalam $ lebih murah; minus membuat lebih mahal.</div>
        <button data-testid="fx-save-btn" type="submit" disabled={saving} className={btnPrimary}>{saving ? "Menyimpan..." : "Simpan"}</button>
      </form>
    </Panel>
  );
}
